/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OnEarly Core API
 * OnEarly Core HTTP API
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const ContentPerformAsInput = zod.object({
  actorUuid: zod.uuid().optional().describe('UUID v4 identifier'),
  principalType: zod.enum(['USER', 'GROUP', 'GROUP_MEMBER']),
});

export type ContentPerformAsInput = zod.input<typeof ContentPerformAsInput>;
export type ContentPerformAsInputOutput = zod.output<typeof ContentPerformAsInput>;
